import { Box, Button, Typography, LinearProgress } from '@mui/material';
import { styled } from '@mui/material/styles';
import pallet from '../../../layouts/pallet';
import { fontSizes } from '../../../layouts/fontSizes';
import { DataGrid } from '@mui/x-data-grid';
import { dataGridSx } from '../../common/styled/DataGrid';

const FiltersContainer = styled(Box)`
  display: flex;
  gap: 16px;
`;

const FilterColumn = styled(Box)`
  display: flex;
  flex-direction: column;
`;

const FilterLabel = styled(Typography)`
  font-weight: 600 !important;
  margin-bottom: 4px !important;
  margin-left: 4px !important;
  color: ${pallet.formLabelText};
  font-size: ${fontSizes.subtitle} !important;
`;

const StyledTextField = styled(Box)`
  width: 170px !important;
`;

const ActionsContainer = styled(Box)`
  display: flex;
  align-items: flex-end;
  gap: 16px;
  justify-content: flex-end;
  width: 100%;
`;

const RoundedButton = styled(Button)`
  border-radius: 8px !important;
  width: 170px !important;
`;

const StyledLinearProgress = styled(LinearProgress)`
  margin-bottom: 8px;
`;

const StyledRolloverDataGrid = styled(DataGrid)(() => ({
  ...dataGridSx(pallet),
  '& .MuiDataGrid-virtualScroller': { overflowY: 'auto' }
}));

export {
  FiltersContainer,
  FilterColumn,
  FilterLabel,
  StyledTextField,
  ActionsContainer,
  RoundedButton,
  StyledLinearProgress,
  StyledRolloverDataGrid
};
